(function () {
  var root = document.documentElement;

  /* ------------------------------------------------------------------
     1) Header-offset measurement.

     The theme's sticky-header component collapses to height 0 on some
     templates (its children position: fixed), so the --header-height
     var is unreliable. Measure the actual rendered header and publish
     a --styled-with-top var that the sidebar uses for its sticky top
     offset: header.height + (header.top → first interactive child.top),
     which gives the sidebar heading the same vertical breathing room
     below the header's bottom edge as the header's own top padding.
  ------------------------------------------------------------------- */
  function measureHeaderOffset() {
    var header =
      document.querySelector('sticky-header header') ||
      document.querySelector('.header-wrapper .header') ||
      document.querySelector('header.header');
    if (!header) return;
    var headerRect = header.getBoundingClientRect();
    var headerHeight = headerRect.height || 0;
    if (headerHeight === 0) return;

    // Measure the top gap between the header's edge and its first
    // vertically-centred UI row. Prefer the nav menu or the right-side
    // icons group — both share the same top inset as the "Search" text
    // the user described. Skip anchors that resolve to y=0 (dropdowns
    // whose descendants position themselves outside the header) or that
    // sit below half the header (dropdown targets open downward).
    var candidates = [
      '.header__inline-menu',
      '.header__icons',
      '.header__icon--account',
    ];
    var topInset = 0;
    for (var i = 0; i < candidates.length; i++) {
      var el = header.querySelector(candidates[i]);
      if (!el) continue;
      var inset = el.getBoundingClientRect().top - headerRect.top;
      if (inset > 0 && inset < headerHeight / 2) {
        topInset = inset;
        break;
      }
    }

    root.style.setProperty('--styled-with-top', headerHeight + topInset + 'px');
  }

  /* ------------------------------------------------------------------
     2) Scroll handoff.

     When the visitor scrolls and the main-product section's bottom is
     within `maxScroll` pixels of the viewport bottom (i.e. the section
     is about to end), advance the sidebar's internal scroll in step so
     the remaining items glide past before the next section takes over.

     Only drives forward — if the visitor manually scrolled the sidebar
     ahead of the page-driven target we leave their position alone.
  ------------------------------------------------------------------- */
  function updateHandoff() {
    var product = document.querySelector('.product.product--with-styled-with');
    var sidebar = document.querySelector('.product__styled-with-wrapper');
    var scroller = document.querySelector('.product__styled-with__scroll');
    if (!product || !sidebar || !scroller) return;

    var maxScroll = scroller.scrollHeight - scroller.clientHeight;
    if (maxScroll <= 0) return;

    var productBottom = product.getBoundingClientRect().bottom;
    var viewportH = window.innerHeight;
    var distanceToEnd = productBottom - viewportH;

    if (distanceToEnd < 0 || distanceToEnd > maxScroll) return;

    var target = maxScroll - distanceToEnd;
    if (scroller.scrollTop < target) {
      scroller.scrollTop = target;
    }
  }

  /* ------------------------------------------------------------------
     Wiring — both behaviours only apply at >=990px where the sidebar
     is a sticky third column. Skip listeners on narrow viewports so we
     don't run useless work on mobile.
  ------------------------------------------------------------------- */
  var desktopMql = window.matchMedia('(min-width: 990px)');
  var scrolling = false;

  function onScroll() {
    if (scrolling) return;
    scrolling = true;
    requestAnimationFrame(function () {
      updateHandoff();
      scrolling = false;
    });
  }

  function syncListeners() {
    if (desktopMql.matches) {
      measureHeaderOffset();
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      window.removeEventListener('scroll', onScroll);
    }
  }

  function init() {
    syncListeners();
    window.addEventListener('resize', function () {
      measureHeaderOffset();
      syncListeners();
    });
    if (desktopMql.addEventListener) {
      desktopMql.addEventListener('change', syncListeners);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
